module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/core-js/object/freeze.js
// module id = 1123
// module chunks = 168707334958949